import React, { useState, useEffect } from 'react'
import { path, pluck } from 'ramda'
import { useHistory, useParams, useLocation } from 'react-router-dom'
import { getStaffType } from '../../../../services/commonServices'
import { message } from 'antd'
import { config } from '../../../../config/Structure'
import CrudForm from '../../../Form'
import { connect } from 'react-redux'
import { uploadImages } from '../../../../config/Client/actions/Upload'
import { getCompanyDistributors } from '../../../Company/store/actions'
import queryString from 'query-string'

const EditRepForm = ({ dispatch, state }) => {
  const { reps } = config
  const { id } = useParams()
  const history = useHistory()
  const location = useLocation()
  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const query = queryString.parse(location.search)

  useEffect(() => {
    setLoading(true)

    // verify user access privileges
    if (path(['auth', 'user', 'staff'], state)) {
      if (getStaffType(path(['auth', 'user', 'staff'], state)) === 'company') {
        dispatch(
          getCompanyDistributors({
            query: { _id: path(['auth', 'user', 'staff', 'sellerRef', '_id'], state) },
            onSuccess: accessVerificationOnSuccess,
            onFailure: accessVerificationOnFailure,
          })
        )
      }
    }

    //get initial values
    dispatch(
      config.reps.edit.get({
        query: { _id: id },
        onSuccess: onFetchSuccess,
        onFailure: onFetchFailure,
      })
    )
  }, []) // eslint-disable-line

  const onSubmit = (values) => {
    setSubmitting(true)
    dispatch(
      uploadImages({
        values,
        imageArray: values.images,
        moduleName: 'reps',
        _id: id,
        onSuccess: onUploadSuccess,
        onFailure,
      })
    )
  }

  const accessVerificationOnSuccess = (result) => {
    if (!pluck('_id', result).includes(query.distributor))
      history.push(`/companies/view/${path(['auth', 'user', 'staff', 'sellerRef', '_id'], state)}`)
  }

  const accessVerificationOnFailure = (error) => {
    console.log('error: ', error)
    history.push(`/companies/view/${path(['auth', 'user', 'staff', 'sellerRef', '_id'], state)}`)
  }

  const onUploadSuccess = (imageLinkArray, values) => {
    values.images = imageLinkArray
    dispatch(reps.edit.update({ body: { ...values, _id: id }, onSuccess, onFailure }))
  }

  const onSuccess = () => {
    setSubmitting(false)
    message.success('تم التعديل بنجاح')
    history.push(`/reps${location.search}`)
  }

  const onFailure = (error) => {
    setSubmitting(false)
    message.error('حدث خطأ')
  }

  const onFetchSuccess = (records) => {
    const fetchedRecord = records.data[Object.keys(records.data)[0]]
    const record = {
      ...fetchedRecord,
      phone: fetchedRecord.phone[0],
      zones: pluck('_id', fetchedRecord.zones),
    }
    setLoading(false)
    if (query['distributor'] && path(['distributor', '_id'], record) !== query['distributor']) {
      return history.push('/companies')
    }
    setData(record)
  }

  const onFetchFailure = (error) => {
    setLoading(false)
    message.error('حدث خطأ')
  }

  return (
    <CrudForm
      title="تعديل المندوب"
      loading={loading}
      fields={config.reps.edit.fields}
      onSubmit={onSubmit}
      buttonText="تعديل"
      initialValues={data}
      submitting={submitting}
    />
  )
}

const mapStateToProps = (state) => ({
  state,
})

export default connect(mapStateToProps)(EditRepForm)
